// =====================================
//
//   已付款但尚未審核的訂單 申請退款 Modal
//   Author: Gray
//   createtime: 2016 / 03 / 29
//   updatetime: 2016 / 03 / 29
//
// =====================================

window.InifECApp.directive('confirmPaidRefund', ['$rootScope', '$stateParams', '$timeout', '$ngModal', 'RefundrecService',
    function($rootScope, $stateParams, $timeout, $ngModal, RefundrecService) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            // --------------------------------
            // [private] 打開 Modal
            // --------------------------------
            var openModal = function() {

                $ngModal.openModal('confirm-paid-refund-modal');
            }

            // --------------------------------
            // [private] 關閉 Modal
            // --------------------------------
            var closeModal = function() {

                $ngModal.closeModal('confirm-paid-refund-modal');
            }

            // --------------------------------
            // 確定取消訂單
            // --------------------------------
            var submit = function(){

                if($scope.isLoading){
                    return;
                }

                $scope.errorMsg = '';
                $scope.isAccountNameEmpty = false;
                $scope.isBankCodeEmpty = false;
                $scope.isBankBranchEmpty = false;
                $scope.isAtmAccountEmpty = false;
                $scope.isReAtmAccountEmpty = false;
                $scope.isNotSameError = false;

                if($scope.isNeedRefundInfo) {

                    if($scope.isUploadAccountInfo) {
                        if(!$scope.form.file) {
                            $scope.isFileEmpty = true;
                            $scope.errorMsg = '請上傳帳戶影本照片。';
                        }
                    } else {
                        if(!$scope.form.accountName) {
                            $scope.isAccountNameEmpty = true;
                            $scope.errorMsg = '請填寫退款資料。';
                        }

                        if(!$scope.form.bankCode) {
                            $scope.isBankCodeEmpty = true;
                            $scope.errorMsg = '請填寫退款資料。';
                        }

                        if(!$scope.form.bankBranch) {
                            $scope.isBankBranchEmpty = true;
                            $scope.errorMsg = '請填寫退款資料。';
                        }

                        if(!$scope.form.atmAccount) {
                            $scope.isAtmAccountEmpty = true;
                            $scope.errorMsg = '請填寫退款資料。';
                        }

                        if(!$scope.form.reAtmAccount) {
                            $scope.isReAtmAccountEmpty = true;
                            $scope.errorMsg = '請填寫退款資料。';
                        }

                        if($scope.form.atmAccount && $scope.form.reAtmAccount && $scope.form.atmAccount != $scope.form.reAtmAccount) {
                            $scope.isNotSameError = true;
                            $scope.errorMsg = '兩次資料不一致。';
                        }
                    }
                }

                if($scope.errorMsg) {
                    return;
                } 

                var orderid = $scope.order.orderid,
                    accountName,
                    bankCode,
                    atmAccount,
                    file,
                    bankBranch = $scope.form.bankBranch;

                if($scope.isUploadAccountInfo) {
                    file = $scope.form.file;
                } else {
                    accountName = $scope.form.accountName;
                    bankCode = $scope.form.bankCode;
                    atmAccount = $scope.form.atmAccount;
                }

                $scope.isLoading = true;

                RefundrecService.discardPaidOrder(orderid, accountName, bankCode, atmAccount, file, bankBranch).then(function(result) {

                    if(result){
                        ($scope.callback) && $scope.callback();
                        closeModal();
                        openSuccessMoadl()
                    } else {
                        $scope.errorMsg = '系統發生異常。';
                    }

                    $scope.isLoading = false;

                }, function(error){
                    
                    if(!error || !error.message) {
                        $scope.errorMsg = '系統發生異常。';
                        return;
                    }

                    $scope.errorMsg = error.message;
                    $scope.isLoading = false;
                });
            }

            // --------------------------------
            // 取消
            // --------------------------------
            var cancel = function() {

                closeModal();
            }

            // --------------------------------
            // [private] 成功modal
            // --------------------------------
            var openSuccessMoadl = function() {

                $rootScope.$broadcast("OPEN_SUCCESS_MESSAGE_MODAL", {
                    title: "已成功取消訂單",
                    desc: "您的退款費用將會在14個工作天內退回。"
                });
            }

            // --------------------------------
            // [private] 重置變數
            // --------------------------------
            var reset = function() {

                $scope.form.accountName = '';
                $scope.form.bankCode = '';
                $scope.form.atmAccount = '';
                $scope.form.reAtmAccount = '';
                $scope.form.file = undefined;
                $scope.form.bankBranch = '';
                $scope.form.refundExtrafeeTotal = 0;
                $scope.errorMsg = '';
                $scope.isLoading = false;
                $scope.isAccountNameEmpty = false;
                $scope.isBankCodeEmpty = false;
                $scope.isBankBranchEmpty = false;
                $scope.isAtmAccountEmpty = false;
                $scope.isReAtmAccountEmpty = false;
                $scope.isNotSameError = false;
                $scope.isUploadAccountInfo = false;
                $scope.hasExtraFee = false;
                $scope.isNeedRefundInfo = false;
            }

            // --------------------------------
            // 選擇檔案
            // --------------------------------
            var onFileSelect = function($files) {

                if(!Array.isArray($files) || $files.length == 0) {
                    return;
                }

                $scope.form.file = $files[0];
            }

            // --------------------------------
            // 移除檔案
            // --------------------------------
            var removeFile = function() {

                $scope.form.file = undefined;
            }

            // --------------------------------
            // 選擇填寫方式
            // --------------------------------
            var setIsUploadAccountInfo = function(isUploadAccountInfo) {

                $scope.isUploadAccountInfo = isUploadAccountInfo;
            }
            
            // --------------------------------
            // 取得退款總額（不計算超商手續費）
            // --------------------------------
            var getRefundTotal = function() {

                if($scope.order.csvFee > 0) {
                    return $scope.order.totalamount - $scope.order.csvFee;
                }

                if($scope.order.csvFeeNoTax > 0) {

                    var csvFee = Math.round($scope.order.csvFeeNoTax * 1.05);

                    return $scope.order.totalamount - csvFee;
                }
                
                return $scope.order.totalamount;
            }

            // --------------------------------
            // [private] 初始化
            // --------------------------------
            var init = function() {

                var isNeedRefundInfo = false;
                var hasExtraFee = false;
                var refundExtrafeeTotal = 0;
                var paymentmethod = $scope.order.paymentmethod;
                var orderExtraFeeLogs = $scope.order.orderExtraFeeLogs;

                if(paymentmethod == Paytype_SinopacATM || paymentmethod == Paytype_ManualCash 
                    || paymentmethod == Paytype_OutwardRemittance || paymentmethod == Paytype_Spgateway_Cvs
                ) {
                    isNeedRefundInfo = true;
                }
                
                if(orderExtraFeeLogs && orderExtraFeeLogs.logs) {

                    $.map(orderExtraFeeLogs.logs, function(value, index) {

                        if(value.status == 400) {
                            hasExtraFee = true;
                            refundExtrafeeTotal = refundExtrafeeTotal + value.totalamount;

                            if(value.csvFee > 0) {
                                refundExtrafeeTotal -= value.csvFee;
                            } else if(value.csvFeeNoTax > 0) {
                                refundExtrafeeTotal -= Math.round(value.csvFeeNoTax * 1.05);
                            }

                            if(isNeedRefundInfo) {
                                return;
                            }

                            paymentmethod = value.paymentmethod;

                            if(paymentmethod == Paytype_SinopacATM || paymentmethod == Paytype_ManualCash 
                                || paymentmethod == Paytype_OutwardRemittance || paymentmethod == Paytype_Spgateway_Cvs
                            ) {
                                isNeedRefundInfo = true;
                            }
                        }
                    });
                }

                $scope.hasExtraFee = hasExtraFee;
                $scope.isNeedRefundInfo = isNeedRefundInfo;
                $scope.form.refundExtrafeeTotal = refundExtrafeeTotal;

                openModal();
            }

            /*==========================
                Events
            ==========================*/

            $scope.$on("OPEN_CONFIRM_PAID_REFUND_MODAL", function(event, data) {

                if(data) {
                    reset();

                    $scope.order = data.order;
                    $scope.callback = data.callback;

                    init();
                }
            });
                
            /*==========================
                Members
            ==========================*/
            $scope.form = {
                accountName: '',
                bankCode: '',
                atmAccount: '',
                reAtmAccount: '',
                file: undefined,
                bankBranch: '',
                refundExtrafeeTotal: 0,
            };

            $scope.order;
            $scope.errorMsg;
            $scope.isLoading = false;
            $scope.isAccountNameEmpty = false;
            $scope.isBankCodeEmpty = false;
            $scope.isBankBranchEmpty = false;
            $scope.isAtmAccountEmpty = false;
            $scope.isReAtmAccountEmpty = false;
            $scope.isNotSameError = false;
            $scope.isUploadAccountInfo = false;
            $scope.hasExtraFee = false;
            $scope.isNeedRefundInfo = false;

            /*==========================
                Methods
            ==========================*/
            $scope.callback = undefined;
            $scope.submit = submit; // 確定取消訂單
            $scope.cancel = cancel; // 取消
            $scope.onFileSelect = onFileSelect; // 選擇檔案
            $scope.removeFile = removeFile; // 移除檔案
            $scope.setIsUploadAccountInfo = setIsUploadAccountInfo; // 選擇填寫方式
            $scope.getRefundTotal = getRefundTotal; // 取得退款總額（不計算超商手續費）

            /*==========================
                init
            ==========================*/

            // init();

        }]

        _dir.restrict = 'E';
        _dir.scope = true;
        _dir.templateUrl = 'partials/modal/confirm_paid_refund.html';
        _dir.controller = controller;

        return _dir;
}]);